import {
    PhoneOutlined,
    PlusOutlined,
    SearchOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Avatar, Badge } from "antd";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    getMarketInfoCollectionThunk,
    getTaskListsThunk,
    getUserTeamGetByManagerThunk,
} from "tm-shared/api";

import FlexContainer from "@/components/FlexContainer";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { SecondaryText } from "@/components/Typography/Styled";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { clearMarkets, clearTasks } from "@/store/slices/work/work.slice";

import {
    TeamMemberBlock,
    UserInfoDescriptionLink,
    UserInfoTitle,
} from "./Styled";

function MemberInfo() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { team } = useAppSelector((state) => state.sv);
    const { userId, userRole } = useParams();
    const { marketIds } = useAppSelector((state) => state.work);

    useEffect(() => {
        dispatch(clearTasks());
        dispatch(
            getUserTeamGetByManagerThunk({
                managerId: userId,
            }),
        );
    }, []);

    useEffect(() => {
        if (marketIds?.length) {
            dispatch(
                getMarketInfoCollectionThunk({
                    marketIds,
                }),
            );
            dispatch(
                getTaskListsThunk({ targetIds: marketIds, roleSlug: userRole }),
            );
        }
    }, [dispatch, marketIds]);

    useEffect(() => {
        dispatch(clearMarkets());
    }, [dispatch]);

    return (
        <>
            <Meta title="Profile" />
            <Header title="Деталі команди" back />
            <MainContainer>
                {team?.members?.map((member) => (
                    <TeamMemberBlock key={member?.userId}>
                        <FlexContainer
                            width="60%"
                            justifyContent="flex-start"
                            gap="8px"
                        >
                            <Badge
                                dot={true}
                                style={{
                                    backgroundColor: member?.isWorking
                                        ? "#52c41a"
                                        : "#BF2E2D",
                                    top: "36px",
                                    left: "27px",
                                    height: "10px",
                                    width: "10px",
                                }}
                            >
                                <Avatar
                                    style={{ width: "42px", height: "42px" }}
                                    icon={<UserOutlined />}
                                />
                            </Badge>
                            <FlexContainer
                                flexDirection="column"
                                alignItems="flex-start"
                                gap="8px"
                                width="100%"
                            >
                                <UserInfoTitle>
                                    {member?.fullName}
                                </UserInfoTitle>
                                {member?.isWorking ? (
                                    <SecondaryText>
                                        Почав о{" "}
                                        {dayjs(member?.startedAt).format(
                                            "H:mm",
                                        )}
                                    </SecondaryText>
                                ) : (
                                    <SecondaryText>Не на роботі</SecondaryText>
                                )}
                                <FlexContainer
                                    width="100%"
                                    justifyContent="space-between"
                                >
                                    <UserInfoDescriptionLink
                                        href={`tel:${member?.phone}`}
                                    >
                                        {member?.phone}
                                    </UserInfoDescriptionLink>
                                    <UserInfoDescriptionLink
                                        href={`tel:${member?.phone}`}
                                    >
                                        <PhoneOutlined />
                                    </UserInfoDescriptionLink>
                                </FlexContainer>
                            </FlexContainer>
                        </FlexContainer>
                        <Avatar
                            style={{
                                backgroundColor: "#49AA19",
                                cursor: "pointer",
                            }}
                            size={40}
                            icon={<SearchOutlined />}
                            onClick={() => navigate(`/team/${member.userId}`)}
                        />
                    </TeamMemberBlock>
                ))}
                <Avatar
                    style={{
                        backgroundColor: "#1677FF",
                        cursor: "pointer",
                        position: "absolute",
                        right: 16,
                        bottom: 16,
                    }}
                    size={50}
                    icon={<PlusOutlined style={{ color: "#FFFFFF" }} />}
                    onClick={() =>
                        navigate(`/add-team-member/${userId}/${userRole}`)
                    }
                />
            </MainContainer>
        </>
    );
}

export default MemberInfo;
